import React, { useState, useMemo } from 'react';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import UpdateJobStatusModal from './updateJobStatusModal';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Job Status', path: '/', active: true }
];

const TCardJobStatus = () => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedJobStatusID: null,
        isUpdate: false
    });
    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            selectedJobStatusID: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '2%'
        },
        {
            field: 'tCardStatusDescription',
            title: `Job Status Description`,
            filterable: true,
            sortable: true,
            width: '10%'
        },
        {
            field: 'tCardStatusequence',
            title: `Sequence`,
            filterable: true,
            sortable: true,
            width: '10%'
        }
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            isUpdate: row ? true : false,
            showModal: true,
            selectedJobStatusID: row ? row.tCardStatusID : null
        }));
    };
    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ marginLeft: '5px' }}>
                <abbr title="Add Job Status">
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(null)}>
                        <Add fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <abbr title="Edit Job Status">
                    {' '}
                    <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                        <EditIcon fontSize="small" style={{ color: 'white' }} />
                    </SquareButton>
                </abbr>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);
    const rowDataStyle = (record) => {
        return {
            ['background-color']: record.tCardStatusBackGroundColour || 'white'
        };
    };
    const colDataStyle = (record) => {
        return {
            ['color']: record.tCardStatusTextColour || 'black'
        };
    };

    const baseUrl = 'TCardStatus/TCardStatus_list';

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data,
                            total: res?.data[0]?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                        AddBtn={addButton}
                        setRowStyleOnCondition={true}
                        setRowStyleFunction={rowDataStyle}
                        setColStyleOnCondition={true}
                        setColStyleFunction={colDataStyle}
                    />
                </Grid>
            </Grid>
            {state.showModal ? (
                <DialogComp maxWidth="md" overflow="auto" title={state.isUpdate ? 'Update Job Status' : 'Add Job Status'} onClose={() => handleClose(false)}>
                    <UpdateJobStatusModal onClose={() => handleClose(true)} jobStatusID={state.selectedJobStatusID} isUpdate={state.isUpdate} />
                </DialogComp>
            ) : null}
        </div>
    );
};
export default TCardJobStatus;
